/* globals FileReader */
import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'

import { Colors, Fonts, Metrics } from '../../Themes'
import Button from '../Button'

const OuterContainer = styled.div``

const InnerContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  #picture-upload {
    display: none;
  }

  #default-button {
    pointer-events: none;
  }
`

const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

class UploadPicture extends Component {
  constructor (props) {
    super(props)
    this.handlePictureChange = this.handlePictureChange.bind(this)
  }

  handlePictureChange (event) {
    if (event.target.files) {
      const reader = new FileReader()
      const file = event.target.files[0]
      // Calc the size in MB
      const fileSize = file.size / 1024 / 1024
      switch (file.type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/tiff':
        case 'image/gif':
          break
        default:
          this.props.handleError('Wrong image type')
          return
      }
      if (fileSize > 2) {
        this.props.handleError('Image cannot be greater than 2mb')
      } else {
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          this.props.handleUploaded(file, reader.result)
        }
      }
    }
  }

  render () {
    const { children, uploadButton, error } = this.props
    return (
      <OuterContainer>
        <InnerContainer {...this.props}>
          {children}
          <input
            type='file'
            name='picture-upload'
            id='picture-upload'
            onChange={this.handlePictureChange}
          />
          <label htmlFor='picture-upload' className='uploadButtonContainer'>
            {uploadButton || <Button id='default-button' label={'Upload'} />}
          </label>
        </InnerContainer>
        {error && <Error className='error'>{error}</Error>}
      </OuterContainer>
    )
  }
}

UploadPicture.propTypes = {
  uploadButton: PropTypes.node,
  handleUploaded: PropTypes.func.isRequired,
  handleError: PropTypes.func,
  error: PropTypes.string,
  children: PropTypes.node
}

export default UploadPicture



// WEBPACK FOOTER //
// ./src/components/UploadPicture/index.js